// extracted by css-extract-rspack-plugin
export default {"scrollable":"TmAK8"};